import Companies from '../components/companies/Companies';
import CompaniesCreate from '../components/companies/CompaniesCreate';
import CompaniesEdit from '../components/companies/CompaniesEdit';
import CompaniesSetup from '../components/companies/CompaniesSetup';

const Template = {
  template: '<router-view></router-view>',
};

export default {
  path: '/companies',
  component: Template,
  children: [
    {
      path: '',
      name: 'Companies',
      component: Companies,
      meta: {
        title: 'Companies - Mod24',
      },
    },
    {
      path: 'create',
      name: 'CompaniesCreate',
      component: CompaniesCreate,
      meta: {
        title: 'Create Company - Mod24',
      },
    },
    {
      path: 'edit/:id',
      name: 'CompaniesEdit',
      component: CompaniesEdit,
      meta: {
        title: 'Edit Company - Mod24',
      },
    },
    {
      path: 'setup',
      name: 'CompaniesSetup',
      component: CompaniesSetup,
      meta: {
        title: 'Setup Your Company - Mod24',
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/companiesRoutes.js